module.exports = __webpack_public_path__ + "img/enTxt2.3c7552b0.png";